<template>
  <v-card>
    <v-form ref="dialogForm">
      <v-row>
        <v-col>
          <v-text-field
            v-model="password"
            :counter="15"
            :rules="[
              v => !!v ||  $t('rules.required',{field:$t('password')}),
              v => (v && v.length <= 15) ||  $t('rules.maxLength',{field:$t('password'), number:15}),
              v => (v && v.length >7 ) ||  $t('rules.minLength',{field:$t('password'), number:7}),
            ]"
            :label="$t('password')"
            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
            :type="show ? 'text' : 'password'"
            @click:append="show = !show"
            required
          ></v-text-field>
          
        </v-col>
      </v-row>
      <v-row>
        <v-col>
        <v-text-field
            :counter="15"
            v-model="repeatPassword"
            :rules="[
              v => !!v ||  $t('rules.required',{field:$t('confirmPassword')}),
              v => (v && v.length <= 15) ||  $t('rules.maxLength',{field:$t('confirmPassword'), number:15}),
              v => (v && v.length >7 ) ||  $t('rules.minLength',{field:$t('confirmPassword'), number:7}),
              v => v===password|| $t('rules.missmatch')
            ]"
            :label="$t('confirmPassword')"
            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
            :type="show ? 'text' : 'password'"
            @click:append="show = !show"
            required
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row >        
        <v-col cols="6" class="text-center">
          <v-btn text @click.stop="cancel" class="btn btn-cancel"> {{$t('cancelButton')}} </v-btn>
        </v-col>
        <v-col cols="6" class="text-center">
          <v-btn rounded dark @click.stop="resetPasword" class="btn btn-confirm"> {{$t('acceptButton')}} </v-btn>
        </v-col> 
      </v-row>
    </v-form>
  </v-card>
</template>
<script>
export default {
  props: {
    userId: {
      type: String
    }
  },
  data(){
    return {
      password: '',
      repeatPassword: '',
      show: false
    }
  },
  methods: {
    resetPasword(){
      if(this.$refs.dialogForm.validate())
        this.$extractions.resetPassword({UserId: this.userId, password: this.password, repeatPassword: this.repeatPassword}).then(()=>{
          this.$store.dispatch('snackAlert', true)
        }).catch(()=>{
          this.$store.dispatch('snackAlert', false)
        })
      this.$emit('close')
    },
    cancel(){
      
      this.$emit('close')
    }
  }  
}
</script>
<style>
  
  .btn{
    font-family: 'Roboto', 'sans-serif';
    font-size: 12px!important;
  }
  .btn-confirm{
    background-color: #5f98ed!important;
  }
  .btn-confirm:hover{
    background-color: #5f98ed!important;
  }
  .btn-cancel{
    color: #91919c!important;
  }
  .btn-cancel:hover{
    color: #65656d!important;
  }
  .btn-cancel::before{
    background-color: transparent!important;
  }
</style>